import Container from '@mui/joy/Container'
import { useSeoHead } from '../../hooks/service/useSeoHead'

const SITE_URL = 'https://aquarium.org.ru'
const DEFAULT_IMAGE = `${SITE_URL}/web-app-manifest-512x512.png`

export function AppBasic({ title, desc, image, canonical, og, twitter, jsonLd, children }) {
    const titlePage = title ? `${title} — Аквариум` : 'Аквариум — мессенджер с записями'
    const descPage = desc ? desc : 'Аквариум — мессенджер с записями'
    const canonicalUrl = canonical
        ?? (typeof window !== 'undefined' ? `${SITE_URL}${window.location.pathname}` : SITE_URL)

    useSeoHead({
        title: titlePage,
        description: descPage,
        canonical: canonicalUrl,
        image: image || DEFAULT_IMAGE,
        og: { 'og:type': 'website', 'og:site_name': 'Аквариум', 'og:locale': 'ru_RU', ...og },
        twitter: { 'twitter:card': 'summary_large_image', ...twitter },
        jsonLd,
    })

    return (
        <>
            {children}
        </>
    )
}

export function AppClear(props) {
    return <main><AppBasic {...props} /></main>
}

export function AppProfile({ children, containerSx, nonav = false, ...props }) {
    return (
        <AppBasic {...props}>
            <div className="app">
                <Container maxWidth="sm" className="profile" sx={{ ...containerSx }}>
                    <main style={{ marginBottom: '8rem' }}>
                        {children}
                    </main>
                </Container>
            </div>
        </AppBasic>
    )
}
